"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Type;
(function (Type) {
    Type["Header"] = "header";
    Type["Footer"] = "footer";
})(Type || (Type = {}));
var TBanner = function (_a) {
    var children = _a.children, type = _a.type, rest = __rest(_a, ["children", "type"]);
    var isHeader = type === Type.Header;
    var Element = isHeader ? "header" : "aside";
    var bannerProps = __assign({}, rest, { className: classNames({
            "oui-margin-remove-top": !isHeader,
            "oui-border-top": !isHeader,
            "oui-border-bottom": isHeader
        }) });
    return (React.createElement(Element, __assign({}, bannerProps),
        React.createElement("div", { className: "oui-padding-small" }, children)));
};
exports.TBannerHeader = function (props) { return (React.createElement(TBanner, __assign({}, props, { type: Type.Header }))); };
exports.TBannerFooter = function (props) { return (React.createElement(TBanner, __assign({}, props, { type: Type.Footer }))); };
//# sourceMappingURL=TBanner.js.map